/**
 * Count of saved products on the header wishlist icon.
 *
 * The wishlist app keeps its state in cookies: WISHLIST_PRODUCTS_IDS holds a map
 * of product id to variants, WISHLIST_TOTAL a number. The map is the honest
 * source for "how many products are saved" - the total counts variants, so a
 * single product in two sizes reads as two.
 *
 * The app writes that cookie only after its save call comes back, measured at
 * about two seconds, so a click is followed by a few re-reads rather than one.
 */
const BUBBLE = '[data-wishlist-bubble]';
const COUNT = '[data-wishlist-count]';
const RETRIES = [150, 600, 1500, 2500, 4000, 6000];

function cookie(name) {
  const row = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith(`${name}=`));
  return row ? decodeURIComponent(row.slice(name.length + 1)) : '';
}

function count() {
  const raw = cookie('WISHLIST_PRODUCTS_IDS');
  if (raw) {
    try {
      const map = JSON.parse(raw);
      if (map && typeof map === 'object') return Object.keys(map).length;
    } catch (error) {
      // fall through to the total below
    }
  }
  const total = parseInt(cookie('WISHLIST_TOTAL'), 10);
  return Number.isNaN(total) ? 0 : total;
}

function render() {
  const value = count();
  for (const bubble of document.querySelectorAll(BUBBLE)) {
    const text = bubble.querySelector(COUNT);
    if (text) text.textContent = value > 99 ? '99+' : String(value);
    bubble.toggleAttribute('hidden', value < 1);
  }
}

function renderSoon() {
  render();
  for (const delay of RETRIES) setTimeout(render, delay);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', render, { once: true });
} else {
  render();
}

// the widget lives inside the app's markup, so the click is caught on the way up
document.addEventListener('click', (event) => {
  const target = event.target;
  if (target instanceof Element && target.closest('[class*="wishlist"]')) renderSoon();
});

window.addEventListener('pageshow', render);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) render();
});
